import './tokens-extra.css';
import { clsx } from 'clsx';

/**
 * Placeholder blocks while data loads. Flat pale fill that pulses its opacity (no shimmer
 * gradient, BRAND.md). Hidden from screen readers; pair the screen with a Spinner label or
 * aria-busy on the region.
 *
 *   <Skeleton shape="card" />
 *   <Skeleton shape="line" lines={3} />
 */
export interface SkeletonProps {
  shape?: 'line' | 'card' | 'circle' | 'block';
  lines?: number;
  className?: string;
}

export function Skeleton({ shape = 'line', lines = 1, className }: SkeletonProps) {
  if (shape === 'line') {
    return (
      <div className={clsx('flex flex-col gap-2', className)} aria-hidden="true">
        {Array.from({ length: lines }, (_, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder rows never reorder
            key={i}
            className={clsx(
              'tts-ui-pulse h-4 rounded-chip border-2 border-ink/40 bg-lilac-pale',
              i === lines - 1 && lines > 1 ? 'w-2/3' : 'w-full',
            )}
          />
        ))}
      </div>
    );
  }
  const shapeCls = {
    card: 'h-28 w-full rounded-tts',
    circle: 'size-12 rounded-full',
    block: 'h-12 w-full rounded-tts',
  }[shape];
  return (
    <div
      aria-hidden="true"
      className={clsx('tts-ui-pulse border-(length:--tts-border) border-ink/40 bg-lilac-pale', shapeCls, className)}
    />
  );
}
